import {
  Component,
  DestroyRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { EffectifByReasonMap } from '@shared/components/effective-needs/interfaces';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { Formation } from '@shared/models/formation.model';
import { Paramedical } from '@shared/models/paramedical.model';
import { Role } from '@shared/models/role.model';
import { CalendarService } from '@shared/services/calendar.service';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { ParamedicalService } from '@shared/services/paramedical.service';
import { ReasonMapService } from '@shared/services/reasonMap.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { SurgeonOpeningsService } from '@shared/services/surgeon-openings.service';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
// import { TitleCasePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AdjustPlanningPopupComponent } from '@shared/components/adjust-planning-popup/adjust-planning-popup.component';
import { PlanningTuningService } from '@shared/services/planningTuning.service';
import { PythonAPIService } from '@shared/services/pythonApi.service';
import { ToastService } from '@shared/services/toast.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { components, frenchDays } from 'src/app/shared/const/globals.const';
import { Profile } from 'src/app/shared/models/profile.model';
import { ErrorService } from 'src/app/shared/services/error.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UserConfigurationService } from 'src/app/shared/services/userConfiguration.service';
import { UtilisService } from 'src/app/shared/services/utilis.service';
import { LoadingService } from 'src/app/statop/bloc/loading.service';
import { HrsuiteService } from '../hrsuite.service';

@Component({
  selector: 'app-simple-day-needs',
  templateUrl: './simple-day-needs.component.html',
  styleUrls: ['./simple-day-needs.component.scss'],
  standalone: false,
})
export class SimpleDayNeedsComponent implements OnInit, OnChanges, OnDestroy {
  private instanceId: string;

  @Output() public onChange = new EventEmitter<boolean>();

  @Input() public isFriseOnly: boolean = false;

  @Input() public dataPerFormation: {
    formation: Formation;
    scheduleData: any[][];
    coveragePerDate: Array<{ percentage: number; percentageLabel: string }>;
  }[] = [];

  @Input() public dataForAll: {
    scheduleData: any[][];
    coveragePerDate: Array<{ percentage: number; percentageLabel: string }>;
  } = { scheduleData: [], coveragePerDate: [] };

  @Input() public dataPerFormationBefore: {
    formation: Formation;
    scheduleData: any[][];
    coveragePerDate: Array<{ percentage: number; percentageLabel: string }>;
  }[] = [];

  @Input() public dataForAllBefore: {
    scheduleData: any[][];
    coveragePerDate: Array<{ percentage: number; percentageLabel: string }>;
  } = { scheduleData: [], coveragePerDate: [] };

  // When we render this component in full frise mode
  // to visualize changes after adjustement,
  // We need to provide matching date to have coherent views
  @Input() public inputDay: moment.Moment | undefined | null;

  @Input() public isAdjustment: boolean = false;

  @Input() public inputDayHours: { hour: string; halfHour?: string }[] = [];

  public timer: NodeJS.Timeout | undefined;

  public osComponentOptions = {
    className: 'os-theme-dark custom-sidebar',
    nativeScrollbarsOverlaid: {
      showNativeScrollbars: true,
    },
    overflowBehavior: {
      x: 'scroll',
      y: 'hidden',
    },
    paddingAbsolute: true,
    scrollbars: {
      autoHide: 'never',
      clickScrolling: true,
    },
  };

  public showDayNight: boolean = false;

  public dayNightOptions = [
    {
      label: 'Jour',
      value: false,
      icon: 'light_mode',
    },
    {
      label: 'Nuit',
      value: true,
      icon: 'dark_mode',
    },
  ];

  public isNight: boolean = false;

  public day: string | undefined;

  public days = frenchDays;

  public inactiveDaysMap: boolean[][] = [];

  public populationList: any[] = [];

  public dayNeeds: number[] = new Array(7).fill(0);

  public dayEffectifs: number[] = new Array(7).fill(0);

  public lastUpdateDate: Date | undefined;

  public subtitle: string | undefined;

  // Only day and month
  public weekDays: string[] = [];

  // day, month and year
  public fullDays: string[] = [];

  public isDataLoading: boolean = true;

  private previousDay: string | undefined;

  public thereIsChange: boolean = false;

  public isoDate: string | undefined;

  public refreshDateSubject: Subject<void> = new Subject<void>();

  public lastUpdateMessage: string | undefined;

  public formations: Formation[] = [];

  public tempFormations: Formation[] = [];

  public selectedFormation: Formation | null | { name: 'All'; _id: '0' } = null;

  public selectedReasonMaps: any[] = [];

  public selectedReasonMapsAfterAdjustment: any[] = [];

  public indexTable: number = 0;

  public showReasonMapsFromAdjustmentAlgo = false;

  public currentPopulation: FormControl = new FormControl();

  public accessOption: AccessOptions | undefined;

  public needsTables: any[] = [];

  public reasonMaps: any[] = [];

  public tempReasonMaps: any[] = [];

  private surgeonOpenings: any[] = [];

  private paramedicals: Paramedical[] = [];

  private effectifByReasonMap: EffectifByReasonMap[] | undefined;

  private allDays: string[] = [];

  public nbDays = 0;

  public periods: string[];

  public isLoading$: Observable<boolean> | undefined;

  public progress$: Observable<number> | undefined;

  public loadingText$: Observable<string> | undefined;

  public numberOfRows: number | undefined;

  public numberOfBorders: number | undefined;

  private startHour: number | null = null;

  private endHour: number | null = null;

  public dayHours: { hour: string; halfHour?: string }[] = [];

  private intervals: Array<{ start: string; end: string }> = [];

  public scheduleData: any[] = [];

  public scheduleDataAfterAdjustment: any[] = [];

  // Utilisé pour la pop up qui apparaît
  // depuis les effectifs besoins dans les demandes RH
  public scheduleDataAfter: any[] = [];

  public selectedDayIndex?: number;

  private readonly ROW_HEIGHT_PX = 40;

  private readonly BORDER_HEIGHT_PX = 2;

  private timeSlotMap: Map<string, { startPercent: number; endPercent: number; middlePercent: number }> = new Map();

  public adjustmentReasonMaps: any[] = [];

  public suggestedReasonMaps: any[] = [];

  public useIndex: boolean = false;

  public showFrise: boolean = true;

  public showDailyFrise: boolean = true; // <- Sur la vue PSC (campagne), on ne veut pas de frise, juste la table des CH

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public readonly data: any,
    @Optional() private readonly dialogRef: MatDialogRef<SimpleDayNeedsComponent>,
    private readonly pythonAPIService: PythonAPIService,
    private readonly utilisService: UtilisService,
    private readonly hrsuiteService: HrsuiteService,
    private readonly userService: UserService,
    private readonly errorService: ErrorService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly reasonMapService: ReasonMapService,
    private readonly paramedicalService: ParamedicalService,
    private readonly surgeonOpeningService: SurgeonOpeningsService,
    private readonly navigationService: NavigationService,
    private readonly calendarService: CalendarService,
    private readonly userConfigurationService: UserConfigurationService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService,
    private readonly dialog: MatDialog,
    private readonly planningTuningService: PlanningTuningService,
    private readonly toastService: ToastService,
    private readonly loadingService: LoadingService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    this.accessOption = this.userService.getAccessOptionsOfPage(this.router.url);
    this.periods = this.accessOption && this.accessOption.periods ? this.accessOption.periods : ['NIGHT', 'DAY'];
    const nightAccessOption = this.userService.getAccessOptionsOfPage('/hrsuite/besoinsgarde');

    if (nightAccessOption && this.periods.includes('NIGHT')) {
      this.showDayNight = true;
    }

    this.saveAnesthNeedsListener();
    this.refreshAnesthNeedsListener();
    this.listenToPlanningAdjustmentEvents();

    if (this.data && this.data.isPopUp) {
      this.showDailyFrise = this.data.showDailyFrise;
    }
  }

  toggleShowFrise() {
    this.showFrise = !this.showFrise;

    this.updateDisplayFriseHebdoToggle();
  }

  updateDisplayFriseHebdoToggle() {
    this.subscriptionManager
      .createRequest(
        this.userConfigurationService.modifyUserConfigurations({
          displayFriseHebdo: this.showFrise,
        }),
        'updateDisplayFriseHebdoToggle',
        this.instanceId
      )
      .subscribe({
        next: () => {
          /* empty */
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  listenToPlanningAdjustmentEvents() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.adjustPlanningSubject, 'adjustPlanningSubject', this.instanceId)
      .subscribe({
        next: () => {
          this.openAlgoPopup(false);
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  @HostListener('window:beforeunload')
  saveDate() {
    this.utilisService.saveDate(components.INFIRMIER_COMPONENT, this.day);
  }

  startLoading(weeks: number) {
    this.loadingService.startLoading('Ajustement en cours...');
    const duration = 60000 * weeks;
    const interval = 100;
    let progress = 0;
    const step = (99 / duration) * interval;
    this.timer = setInterval(() => {
      progress += step;
      if (progress > 20) {
        this.loadingService.text$ = 'Ajustement en cours...';
      }
      if (progress > 70) {
        this.loadingService.text$ = 'Ajustement en cours...';
      }
      if (progress > 90) {
        this.loadingService.text$ = 'Ajustement en cours...';
      }
      if (progress >= 99) {
        clearInterval(this.timer);
      } else {
        this.loadingService.updateProgress(progress);
      }
    }, interval);
  }

  finishLoading(errorText?: string) {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (errorText) {
      this.loadingService.text$ = errorText;
    } else {
      this.loadingService.text$ = 'Ajustement terminé !';
      this.loadingService.updateProgress(100);
    }
    setTimeout(() => {
      this.loadingService.stopLoading();
    }, 1000);
  }

  async openAlgoPopup(validate: any, config: any = {}) {
    const hospital = this.userService
      .getCurrentUser()
      ?.profile?.hospitals?.find((hospital: any) => hospital._id === this.userService.getUserPrincipalHospitalId());
    let fromDate = null;
    let toDate = null;
    if (this.allDays && this.allDays[0] && this.allDays[6]) {
      fromDate = new Date(this.allDays[0]).toISOString();
      toDate = new Date(this.allDays[6]).toISOString();
    }
    const dialogRef = this.dialog.open(AdjustPlanningPopupComponent, {
      width: '1168px',
      minHeight: '800px',
      data: {
        validate: validate,
        hospital: hospital?._id || '',
        positions: this.accessOption?.positions || [],
        config: config,
        fromDate: fromDate,
        toDate: toDate,
      },
    });

    this.subscriptionManager
      .createRequest(dialogRef.componentInstance.onDataGenerated, 'onDataGenerated', this.instanceId)
      .subscribe({
        next: (result: any) => {
          if (result) {
            dialogRef.close();

            this.isLoading$ = this.loadingService.isLoading$;
            this.progress$ = this.loadingService.progress$;
            this.loadingText$ = this.loadingService.text$;
            const start = new Date(result.startDate);
            const end = new Date(result.endDate);
            const diffInMs = end.getTime() - start.getTime();
            const weeks = Math.ceil(diffInMs / (1000 * 60 * 60 * 24 * 7));
            this.startLoading(weeks);
            if (result.isValidate) {
              this.subscriptionManager
                .createRequest(
                  this.planningTuningService.validatePlanning(result.planningId),
                  'validatePlanning',
                  this.instanceId
                )
                .subscribe({
                  next: () => {
                    this.finishLoading();
                    this.hrsuiteService.profilesUpdateSubject.next('');
                    this.toastService.displayToast('Validation effectuée avec succès', 2000);
                  },
                  error: (error: any) => {
                    this.finishLoading();
                    this.hrsuiteService.profilesUpdateSubject.next('');
                    this.errorService.handleError(error);
                  },
                });
            } else {
              this.subscriptionManager
                .createRequest(this.pythonAPIService.adjustPlanning(result._id), 'adjustPlanning', this.instanceId)
                .subscribe({
                  next: () => {
                    this.finishLoading();
                    this.toastService.displayToast('Ajustement effectué avec succès', 2000);
                    setTimeout(() => {
                      this.openAlgoPopup(true, result);
                    }, 1000);
                  },
                  error: (error: any) => {
                    this.finishLoading();
                    this.errorService.handleError(error);
                    setTimeout(() => {
                      this.openAlgoPopup(true, result);
                    }, 1000);
                  },
                });
            }
          }
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  prev() {
    if (this.selectedDayIndex! > 0) {
      this.selectedDayIndex! -= 1;
    }
  }

  next() {
    if (this.selectedDayIndex! < this.nbDays - 1) {
      this.selectedDayIndex! += 1;
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes['inputDay']) {
      this.nbDays = this.data?.nbDays ?? 7;
      this.initStartDate();
      this.day = this.isoDate;
      this.previousDay = this.day;
      this.needsTables = [];
      this.weekDays = [];
      this.fullDays = [];
      this.allDays = [];
      for (let i = 0; i < this.nbDays; i++) {
        this.weekDays.push(this.calculateWeekDays(i));
        this.fullDays.push(this.calculateFullDays(i));
      }

      if (this.data?.isPopUp) {
        if (this.data?.dayIndex !== undefined) {
          this.selectedDayIndex = this.data.dayIndex;
        } else {
          this.selectedDayIndex = 0;
        }
      }

      this.useIndex = this.data?.needsTables && this.data?.effectifByReasonMap;
      if (this.useIndex) {
        this.needsTables = cloneDeep(this.data.needsTables);
        this.effectifByReasonMap = cloneDeep(this.data.effectifByReasonMap);
        this.computeDayNeedsAndEffectifs();
      } else if (!this.isFriseOnly) {
        this.getSurgeonOpenings();
      }
    }
  }

  async ngOnInit() {
    this.subscriptionManager.createRequest(this.activatedRoute.queryParams, 'queryParams', this.instanceId).subscribe({
      next: async (data: any) => {
        if (data.date) {
          this.isoDate = moment.utc(data.date).startOf('isoWeek').format();
          this.day = this.isoDate;
        }
      },
      error: (error: any) => this.errorService.handleError(error),
    });

    await this.initFormations();
    this.nbDays = this.data?.nbDays ?? 7;
    this.initDays();
    if (!this.isoDate) {
      this.initStartDate();
    }
    this.isDataLoading = true;
    this.initPopulation();
    this.day = this.isoDate;
    this.subtitle = this.data?.subTitle;
    this.lastUpdateDate = this.data?.lastUpdateDate?.LastUpdateDate;
    this.previousDay = this.day;
    this.needsTables = [];
    this.weekDays = [];
    this.fullDays = [];
    this.allDays = [];
    for (let i = 0; i < this.nbDays; i++) {
      this.weekDays.push(this.calculateWeekDays(i));
      this.fullDays.push(this.calculateFullDays(i));
    }
    if (this.data?.isPopUp) {
      if (this.data?.dayIndex !== undefined) {
        this.selectedDayIndex = this.data.dayIndex;
      } else {
        this.selectedDayIndex = 0;
      }
    }

    this.useIndex = this.data?.needsTables && this.data?.effectifByReasonMap;
    if (this.useIndex) {
      this.needsTables = cloneDeep(this.data.needsTables);
      this.effectifByReasonMap = cloneDeep(this.data.effectifByReasonMap);
      this.computeDayNeedsAndEffectifs();
    } else if (!this.isFriseOnly) {
      this.getSurgeonOpenings();
    } else {
      this.dayHours = this.inputDayHours;
      this.updateScheduleData(true);
    }
  }

  updateScheduleData(init: boolean = false) {
    if (init) {
      this.tempFormations = this.dataPerFormation.map((data) => data.formation);
      this.selectedFormation = this.tempFormations.length === 1 ? this.tempFormations[0] : { name: 'All', _id: '0' };
    }

    let scheduleData, coveragePerDate, scheduleDataBefore, coveragePerDateBefore;
    if (this.selectedFormation?.name === 'All') {
      scheduleData = this.dataForAll.scheduleData;
      coveragePerDate = this.dataForAll.coveragePerDate;

      scheduleDataBefore = this.dataForAllBefore.scheduleData;
      coveragePerDateBefore = this.dataForAllBefore.coveragePerDate;
    } else {
      const dataForSelectedFormation = this.dataPerFormation.find(
        (data) => data.formation._id === this.selectedFormation?._id
      );

      const dataForSelectedFormationBefore = this.dataPerFormationBefore.find(
        (data) => data.formation._id === this.selectedFormation?._id
      );

      scheduleData = dataForSelectedFormation?.scheduleData;
      coveragePerDate = dataForSelectedFormation?.coveragePerDate;

      scheduleDataBefore = dataForSelectedFormationBefore?.scheduleData;
      coveragePerDateBefore = dataForSelectedFormationBefore?.coveragePerDate;
    }

    this.scheduleDataAfterAdjustment =
      scheduleData?.map((dayData, dayIndex) => ({
        dayIndex,
        percentage: coveragePerDate?.[dayIndex].percentage,
        percentageLabel: coveragePerDate?.[dayIndex].percentageLabel,
        bars: this.calculateBarPositions(
          dayData.map((interval) => ({
            startTime: interval.startTime,
            endTime: interval.endTime,
            value: interval.value,
            color: interval.value < 0 ? 'red' : 'green',
          }))
        ),
      })) ?? [];

    this.scheduleData =
      scheduleDataBefore?.map((dayData, dayIndex) => ({
        dayIndex,
        percentage: coveragePerDateBefore?.[dayIndex].percentage,
        percentageLabel: coveragePerDateBefore?.[dayIndex].percentageLabel,
        bars: this.calculateBarPositions(
          dayData.map((interval) => ({
            startTime: interval.startTime,
            endTime: interval.endTime,
            value: interval.value,
            color: '',
          }))
        ),
      })) ?? [];

    this.isDataLoading = false;
  }

  computeDayNeedsAndEffectifs(): void {
    const findMatchingNeeds = (needs: any[]) => {
      return needs.filter((need: any) => moment.utc(need.day).toISOString() === this.isoDate);
    };

    if (this.nbDays === 1) {
      if (Array.isArray(this.needsTables)) {
        for (const { reasonMaps } of this.needsTables) {
          if (Array.isArray(reasonMaps)) {
            reasonMaps.forEach((reasonMap: any) => {
              if (Array.isArray(reasonMap.needs)) {
                reasonMap.needs = findMatchingNeeds(reasonMap.needs);
              }
            });
          }
        }
      }
    }

    const formationName = this.selectedFormation?.name ?? '';
    this.indexTable = this.needsTables?.findIndex((needTable: any) => needTable.formation?.name === formationName) || 0;

    if (this.indexTable >= 0) {
      this.selectedReasonMaps = this.needsTables[this.indexTable]?.reasonMaps || [];
    } else {
      const tempFormationsNames = this.tempFormations.map((formation: Formation) => formation.name);
      let selectedReasonMaps: any[] = [];
      this.needsTables?.forEach((needsTable: any) => {
        if (tempFormationsNames.includes(needsTable.formation?.name)) {
          selectedReasonMaps = [...selectedReasonMaps, ...cloneDeep(needsTable.reasonMaps)];
        }
      });
      this.selectedReasonMaps = selectedReasonMaps;
    }
    this.inactiveDaysMap = this.mapInactiveDays(this.selectedReasonMaps);

    Array.from({ length: this.nbDays }).forEach((_: unknown, dayIndex: number) => {
      this.computeDayNeeds(dayIndex, -1);
    });

    this.computeEffectifs();
    this.isDataLoading = false;
  }

  getBarsForDay(dayIndex: number, dayData: any) {
    return [...(this.scheduleData?.[dayIndex]?.bars ?? []), ...dayData.bars];
  }

  getBarsForDay2(dayIndex: number | undefined) {
    if (!dayIndex) {
      dayIndex = 0;
    }
    return [...(this.scheduleData?.[dayIndex]?.bars ?? []), ...(this.scheduleDataAfter?.[dayIndex]?.bars ?? [])];
  }

  private generateScheduleDataFromReasonMaps(): void {
    if (!this.selectedReasonMaps || this.selectedReasonMaps.length === 0 || !this.showDailyFrise) {
      this.scheduleData = [];

      this.dayHours = [];
      this.intervals = [];
      return;
    }

    // Calculate time ranges if not already calculated
    if (this.startHour === null || this.endHour === null) {
      const [startHour, endHour] = this.calculateStartAndEndHours(this.selectedReasonMaps);
      this.startHour = startHour;
      this.endHour = endHour;

      if (this.isAdjustment) {
        const [startHour2, endHour2] = this.calculateStartAndEndHours(this.selectedReasonMapsAfterAdjustment);

        this.startHour = Math.min(this.startHour, startHour2);
        this.endHour = Math.max(this.endHour, endHour2);
      }

      const [dayHours, intervals] = this.generateDayHoursAndIntervals(this.startHour, this.endHour);
      this.dayHours = dayHours;
      this.intervals = intervals;
    }

    // Initialize schedule data for the number days you have (1, 7 or more for a month for ex.)
    const scheduleData = Array.from({ length: this.nbDays }, () =>
      this.intervals.map((interval) => ({
        startTime: interval.start,
        endTime: interval.end,
        value: 0,
        effectif: 0,
        need: 0,
        isCoveredByReasonMaps: false,
      }))
    );

    // Calculate time intervals diffs from reasonMaps diffs
    this.selectedReasonMaps.forEach((reasonMap: any) => {
      const { morningStartTime, afternoonEndTime, diff, effectifs, needs, nightStartTime, nightEndTime } = reasonMap;
      const startTime = morningStartTime || nightStartTime;
      const endTime = afternoonEndTime || nightEndTime;

      if (!startTime || !endTime || !diff) {
        return;
      }

      const startHour = new Date(startTime).getUTCHours();
      const startMinute = new Date(startTime).getUTCMinutes();
      const endHour = new Date(endTime).getUTCHours();
      const endMinute = new Date(endTime).getUTCMinutes();

      // Round to 15-minute intervals
      const roundedStartMinute = Math.floor(startMinute / 15) * 15;
      const roundedEndMinute = endMinute >= 8 ? Math.ceil(endMinute / 15) * 15 : Math.floor(endMinute / 15) * 15;

      const reasonMapStart = startHour * 60 + roundedStartMinute;
      let reasonMapEnd = endHour * 60 + roundedEndMinute;
      if (roundedEndMinute === 60) {
        reasonMapEnd = (endHour + 1) * 60;
      }

      // Find covered intervals
      const coveredIntervals = this.intervals.filter((interval) => {
        const [intervalStartHour, intervalStartMinute] = interval.start.split(':').map(Number);
        const intervalStart = intervalStartHour * 60 + intervalStartMinute;
        return intervalStart >= reasonMapStart && intervalStart < reasonMapEnd;
      });

      // Apply diff values
      diff.forEach((diffValue: number, dayIndex: number) => {
        if (dayIndex < this.nbDays) {
          coveredIntervals.forEach((interval) => {
            const index = scheduleData[dayIndex].findIndex(
              (item) => item.startTime === interval.start && item.endTime === interval.end
            );
            if (index !== -1) {
              scheduleData[dayIndex][index].value += diffValue;
              scheduleData[dayIndex][index].effectif += effectifs[dayIndex];
              scheduleData[dayIndex][index].need += needs && needs.length > 0 ? needs[dayIndex].need : 0;

              scheduleData[dayIndex][index].isCoveredByReasonMaps = true;
            }
          });
        }
      });
    });

    const dayPercentages = this.calculateDayPercentages(scheduleData);
    const mergedScheduleData = this.mergeConsecutiveIntervals(scheduleData);

    // Format final schedule data
    this.scheduleData = mergedScheduleData.map((dayData, dayIndex) => ({
      dayIndex,
      percentage: dayPercentages[dayIndex].percentage,
      percentageLabel: dayPercentages[dayIndex].percentageLabel,
      bars: this.calculateBarPositions(
        dayData.map((interval) => ({
          startTime: interval.startTime,
          endTime: interval.endTime,
          value: interval.value,
          color: this.data?.initialReasonMap || this.data?.reasonMap ? '' : interval.value < 0 ? 'red' : 'green',
        }))
      ),
    }));

    // To render before / after on Demande RH daily frise
    if (this.data?.initialReasonMap || this.data?.reasonMap) {
      const scheduleDataAfter = cloneDeep(scheduleData);

      const initialReasonMap = this.data?.initialReasonMap,
        reasonMap = this.data?.reasonMap;

      // Substract 1 from effective of all intervals covered by the initial RMap
      if (initialReasonMap) {
        const startTime = initialReasonMap.morningStartTime || initialReasonMap.nightStartTime;
        const endTime = initialReasonMap.afternoonEndTime || initialReasonMap.nightEndTime;

        const startHour = new Date(startTime).getUTCHours();
        const startMinute = new Date(startTime).getUTCMinutes();
        const endHour = new Date(endTime).getUTCHours();
        const endMinute = new Date(endTime).getUTCMinutes();

        // Round to 15-minute intervals
        const roundedStartMinute = Math.floor(startMinute / 15) * 15;
        const roundedEndMinute = endMinute >= 8 ? Math.ceil(endMinute / 15) * 15 : Math.floor(endMinute / 15) * 15;

        const reasonMapStart = startHour * 60 + roundedStartMinute;
        let reasonMapEnd = endHour * 60 + roundedEndMinute;
        if (roundedEndMinute === 60) {
          reasonMapEnd = (endHour + 1) * 60;
        }

        const coveredIntervals = this.intervals.filter((interval) => {
          const [intervalStartHour, intervalStartMinute] = interval.start.split(':').map(Number);
          const intervalStart = intervalStartHour * 60 + intervalStartMinute;
          return intervalStart >= reasonMapStart && intervalStart < reasonMapEnd;
        });

        scheduleDataAfter.forEach((dayData) => {
          dayData.forEach((data: { startTime: any; endTime: any; effectif: number; value: number }) => {
            if (
              coveredIntervals.find(
                (interval: { start: any; end: any }) =>
                  data.startTime === interval.start && data.endTime === interval.end
              )
            ) {
              data.effectif -= 1;
              data.value -= 1;
            }
          });
        });
      }

      // Add 1 to effective of all intervals covered by the initial RMap
      if (reasonMap) {
        const startTime = reasonMap.morningStartTime || reasonMap.nightStartTime;
        const endTime = reasonMap.afternoonEndTime || reasonMap.nightEndTime;

        const startHour = new Date(startTime).getUTCHours();
        const startMinute = new Date(startTime).getUTCMinutes();
        const endHour = new Date(endTime).getUTCHours();
        const endMinute = new Date(endTime).getUTCMinutes();

        // Round to 15-minute intervals
        const roundedStartMinute = Math.floor(startMinute / 15) * 15;
        const roundedEndMinute = endMinute >= 8 ? Math.ceil(endMinute / 15) * 15 : Math.floor(endMinute / 15) * 15;

        const reasonMapStart = startHour * 60 + roundedStartMinute;
        let reasonMapEnd = endHour * 60 + roundedEndMinute;
        if (roundedEndMinute === 60) {
          reasonMapEnd = (endHour + 1) * 60;
        }

        const coveredIntervals = this.intervals.filter((interval) => {
          const [intervalStartHour, intervalStartMinute] = interval.start.split(':').map(Number);
          const intervalStart = intervalStartHour * 60 + intervalStartMinute;
          return intervalStart >= reasonMapStart && intervalStart < reasonMapEnd;
        });

        scheduleDataAfter.forEach((dayData) => {
          dayData.forEach((data: { startTime: any; endTime: any; effectif: number; value: number }) => {
            if (
              coveredIntervals.find(
                (interval: { start: any; end: any }) =>
                  data.startTime === interval.start && data.endTime === interval.end
              )
            ) {
              data.effectif += 1;
              data.value += 1;
            }
          });
        });
      }

      const dayPercentagesAfter = this.calculateDayPercentages(scheduleDataAfter);
      const mergedScheduleDataAfter = this.mergeConsecutiveIntervals(scheduleDataAfter);

      this.scheduleDataAfter = mergedScheduleDataAfter.map((dayData, dayIndex) => ({
        dayIndex,
        percentage: dayPercentagesAfter[dayIndex].percentage,
        percentageLabel: dayPercentagesAfter[dayIndex].percentageLabel,
        bars: this.calculateBarPositions(
          dayData.map((interval) => ({
            startTime: interval.startTime,
            endTime: interval.endTime,
            value: interval.value,
            color: interval.value < 0 ? 'red' : 'green',
          }))
        ),
      }));
    }
  }

  private initializeTimeSlotMap(): void {
    if (!this.dayHours || this.dayHours.length === 0) {
      return;
    }

    this.numberOfRows = this.dayHours.length;
    this.numberOfBorders = this.numberOfRows - 1;

    const totalHeightPx = this.ROW_HEIGHT_PX * this.numberOfRows + this.BORDER_HEIGHT_PX * this.numberOfBorders;
    const percentPerPixel = 100 / totalHeightPx;

    this.dayHours.forEach((hour, index) => {
      const startPixel = index * this.ROW_HEIGHT_PX + index * this.BORDER_HEIGHT_PX;
      const endPixel = startPixel + this.ROW_HEIGHT_PX;

      const startPercent = startPixel * percentPerPixel;
      const endPercent = endPixel * percentPerPixel;
      const middlePercent = (startPercent + endPercent) / 2;

      this.timeSlotMap.set(hour.hour, { startPercent, endPercent, middlePercent });
    });
  }

  private calculateBarPositions(
    bars: Array<{ startTime: string; endTime: string; value: number; color: string }>
  ): any[] {
    if (this.timeSlotMap.size === 0) {
      this.initializeTimeSlotMap();
    }

    return bars.map((bar) => {
      const displayValue = Math.max(-3, Math.min(3, bar.value));
      const { topPercent, heightPercent } = this.getPercentagesForTimeRange(bar.startTime, bar.endTime);

      const leftPercent = 50 + displayValue * 13;
      const fillLeftPercent = displayValue >= 0 ? 50 : leftPercent;
      const fillWidthPercent = Math.abs(displayValue * 13);

      return {
        startTime: bar.startTime,
        endTime: bar.endTime,
        value: bar.value,
        displayValue,
        color: bar.color,
        topPercent,
        heightPercent,
        leftPercent,
        fillLeftPercent,
        fillWidthPercent,
      };
    });
  }

  private getPercentagesForTimeRange(
    startTime: string,
    endTime: string
  ): { topPercent: number; heightPercent: number } {
    const startPercent = this.getPercentageForSingleTime(startTime, 'start');
    const endPercent = this.getPercentageForSingleTime(endTime, 'end');

    return {
      topPercent: startPercent,
      heightPercent: endPercent - startPercent,
    };
  }

  private getPercentageForSingleTime(time: string, type: 'start' | 'end'): number {
    const [hours, minutes] = time.split(':').map(Number);
    const hourKey = `${hours.toString().padStart(2, '0')}:00`;
    // For end times at :00, use previous hour's end
    const targetHourKey = type === 'end' && minutes === 0 ? `${(hours - 1).toString().padStart(2, '0')}:00` : hourKey;

    const slot = this.timeSlotMap.get(targetHourKey);
    if (!slot) {
      return 0;
    }

    // Exact matches
    if (minutes === 0) {
      return type === 'start' ? slot.startPercent : slot.endPercent;
    }
    if (minutes === 30) {
      return slot.middlePercent;
    }

    // Interpolation for other minutes
    if (minutes < 30) {
      const fraction = minutes / 30;
      return slot.startPercent + (slot.middlePercent - slot.startPercent) * fraction;
    } else {
      const fraction = (minutes - 30) / 30;
      return slot.middlePercent + (slot.endPercent - slot.middlePercent) * fraction;
    }
  }

  async initFormations() {
    this.formations =
      this.data?.formations ??
      (await this.userService.getAccessOptionsPositionsByPositions(this.accessOption?.positions));
    this.tempFormations = [...this.formations];
    if (this.formations && this.formations.length > 0) {
      if (this.formations.length === 1) {
        this.selectedFormation = this.formations[0];
      } else if (this.data?.selectedFormation) {
        this.selectedFormation = this.data?.selectedFormation;
      } else {
        this.selectedFormation = { name: 'All', _id: '0' };
      }
    }
  }

  initDays() {
    if (this.data?.dayOfTheWeek && this.data.nbDays === 1) {
      this.days = [this.data.dayOfTheWeek];
    }
  }

  initStartDate() {
    if (this.data?.isPopUp) {
      if (this.nbDays === 1) {
        this.isoDate = moment.utc(this.data.date).toISOString();
      } else {
        this.isoDate = this.data.days[0];
      }
    } else if (this.inputDay) {
      this.isoDate = moment.utc(this.inputDay).startOf('isoWeek').toISOString();
    } else {
      // Normalize saved date to start of week to prevent shifting
      const savedDate = this.utilisService.getDate(components.INFIRMIER_COMPONENT);
      if (savedDate) {
        this.isoDate = moment.utc(savedDate).startOf('isoWeek').toISOString();
      }
    }
  }

  async toggleNight() {
    this.navigationService.navigateTo('/hrsuite/besoinsgarde');
  }

  private mapInactiveDays(reasonMaps: any[]) {
    return reasonMaps.map((reasonMap: any) =>
      this.days?.map((_: any, dayIndex: number) => {
        const dayNum = dayIndex + 1 <= 6 ? dayIndex + 1 : 0;
        return !reasonMap.days.includes(dayNum);
      })
    );
  }

  async getReasonMaps() {
    if (!this.reasonMaps || this.reasonMaps.length === 0) {
      this.subscriptionManager
        .createRequest(
          this.reasonMapService.getSuggestedReasonsMaps(true, true),
          'getSuggestedReasonsMaps',
          this.instanceId
        )
        .subscribe({
          next: async (reasonMaps: any) => {
            this.reasonMaps = reasonMaps.filter(
              (reasonMap: any) =>
                !reasonMap.reason.isGarde &&
                reasonMap.reason.period === 'DAY' &&
                reasonMap.reason.availability === 'AVAILABLE' &&
                reasonMap.defaultRoom &&
                reasonMap.defaultSurgeon
            );
            this.tempReasonMaps = this.reasonMaps;
            this.adjustmentReasonMaps = this.reasonMaps.filter((elt: any) => elt.fromAdjustmentAlgo);
            this.suggestedReasonMaps = reasonMaps.filter((elt: any) => !elt.fromAdjustmentAlgo);
            await this.initReasonMapsData();
          },
          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    } else {
      await this.initReasonMapsData();
    }
  }

  getSurgeonOpenings() {
    const startTime = new Date(this.day!);
    const endTime = new Date(this.day!);
    endTime.setDate(endTime.getDate() + 6);
    this.subscriptionManager
      .createRequest(
        this.surgeonOpeningService.getAllSOByWeek(startTime.toISOString(), endTime.toISOString()),
        'getAllSOByWeek',
        this.instanceId
      )
      .pipe(
        switchMap((surgeonOpenings: any) => {
          this.surgeonOpenings = surgeonOpenings;
          return this.calendarService.countEffectifByReasonMap(
            startTime.toISOString(),
            endTime.toISOString(),
            this.formations.map((formation: Formation) => formation?.name ?? ''),
            'DAY'
          );
        })
      )
      .subscribe({
        next: async (effectifByReasonMap: EffectifByReasonMap[]) => {
          this.effectifByReasonMap = effectifByReasonMap;
          await this.getReasonMaps();
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  onChangeSelectedFormation(event: any) {
    this.selectedFormation = event;

    if (this.isFriseOnly) {
      this.updateScheduleData();
      return;
    }

    this.indexTable = this.needsTables?.findIndex(
      (needTable: any) => needTable.role?.name === event.name || needTable.formation?.name === event.name
    );
    this.selectedReasonMaps = [];
    if (this.indexTable !== -1) {
      this.selectedReasonMaps = this.needsTables[this.indexTable]?.reasonMaps;
    } else {
      const tempFormationsNames = this.tempFormations.map((formation: Formation) => formation.name);
      let selectedReasonMaps: any[] = [];
      this.needsTables?.forEach((needsTable: any) => {
        if (tempFormationsNames.includes(needsTable.formation?.name)) {
          selectedReasonMaps = [...selectedReasonMaps, ...cloneDeep(needsTable.reasonMaps)];
        }
      });
      this.selectedReasonMaps = selectedReasonMaps;
    }
    this.inactiveDaysMap = this.mapInactiveDays(this.selectedReasonMaps);

    for (let i = 0; i < 7; i++) {
      this.computeDayNeeds(i, -1);
    }
    this.computeEffectifs();
  }

  updateDiff(event: number | null, index: number, i: number) {
    if (Number.isInteger(this.selectedReasonMaps?.[index]?.effectifs?.[i])) {
      this.selectedReasonMaps[index].diff[i] = this.selectedReasonMaps[index].effectifs[i] - (event ?? 0);
      this.generateScheduleDataFromReasonMaps();
    }
  }

  formatNumber(num: number): number {
    const rounded = Math.round(num * 10) / 10;

    return rounded;
  }

  blockInvalidInput(event: KeyboardEvent, index: number, i: number): void {
    const invalidChars = ['e', 'E', '+', '-', '.', ',', ';'];
    const isNumber = /^[0-9]$/.test(event.key);
    const value = this.needsTables[this.indexTable].reasonMaps[index].needs[i].need;

    if (invalidChars.includes(event.key) || ((event.key === 'ArrowUp' || isNumber) && value >= 999)) {
      event.preventDefault();
    } else if (
      isNumber ||
      event.key === 'Enter' ||
      event.key === 'Backspace' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown'
    ) {
      this.needsTables[this.indexTable].reasonMaps[index].needs[i].modified = true;
      this.change();
    }
  }

  setDefaultIfEmpty(currentValue: any, index: number, i: number) {
    if (currentValue === null || currentValue === undefined || currentValue === '') {
      this.selectedReasonMaps[index].needs[i].need = 0;
      this.needsTables[this.indexTable].reasonMaps[index].needs[i].modified = true;
      this.computeDayNeeds(i, index, 0);
      this.change();
    }
  }

  preventPaste(event: any) {
    event.preventDefault();
  }

  getMatchingSO(dayIndex: any, reasonMap: any) {
    const day = new Date(this.day!);
    day.setDate(day.getDate() + dayIndex);
    day.setUTCHours(0, 0, 0, 0);

    let result;

    for (let index = 0; index < this.surgeonOpenings.length; index++) {
      const room = this.surgeonOpenings[index];
      result = room?.surgeonopening?.find((surgeonOpening: any) => {
        const surgeonDate = new Date(surgeonOpening.date).toISOString().split('T')[0];
        const targetDate = day.toISOString().split('T')[0];

        return (
          surgeonOpening.opening &&
          surgeonDate === targetDate &&
          surgeonOpening.room === reasonMap.defaultRoom &&
          surgeonOpening.surgeon._id === reasonMap.defaultSurgeon
        );
      });

      if (result) {
        return result;
      }
    }

    return undefined;
  }

  async initReasonMapsData() {
    if (!this.paramedicals || this.paramedicals.length === 0) {
      this.subscriptionManager
        .createRequest(this.paramedicalService.getParamedicals(), 'getParamedicals', this.instanceId)
        .subscribe({
          next: (paramedicals: Paramedical[]) => {
            this.paramedicals = paramedicals;
            this.mapReasonMapsToNeedsTables();
            this.onPopulationSelected();
          },
          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    } else {
      this.mapReasonMapsToNeedsTables();
    }
  }

  mapReasonMapsToNeedsTables() {
    const tempNeedsTables: any[] = [];

    this.paramedicals.forEach((paramedical: any) => {
      const { formation, roles } = paramedical;

      this.tempReasonMaps.forEach((reasonMap: any) => {
        if (
          reasonMap?.positions?.includes(formation.name) &&
          (this.showReasonMapsFromAdjustmentAlgo ? true : !reasonMap?.fromAdjustmentAlgo)
        ) {
          roles.forEach((role: { priority: number; roleId: Role }) => {
            let needsTable = tempNeedsTables.find(
              (t: any) => t.formation._id === formation._id && t.role._id === role.roleId._id
            );

            if (!needsTable) {
              needsTable = {
                role: role.roleId,
                formation,
                reasonMaps: [],
              };
              tempNeedsTables.push(needsTable);
            }

            const clonedReasonMap = cloneDeep(reasonMap);
            clonedReasonMap.needs = new Array(this.days.length).fill(0).map((_: any, index: number) => {
              // keep the correct argument order (dayIndex first, then reasonMap)
              const matchingSO: any = this.getMatchingSO(index, reasonMap);

              return {
                matchingSO,
                need:
                  matchingSO?.needs?.find(
                    (need: any) => (need.role?._id ?? need.role) === role.roleId._id // works for both cases
                  )?.need ?? 0,
                day: this.days[index],
              };
            });
            clonedReasonMap.modified = false;

            needsTable.reasonMaps.push(clonedReasonMap);
          });
        }
      });
    });

    this.needsTables = tempNeedsTables;

    this.indexTable =
      this.needsTables?.findIndex((needTable: any) => needTable.formation.name === this.selectedFormation?.name) || 0;

    this.selectedReasonMaps = [];
    if (this.indexTable !== -1) {
      this.selectedReasonMaps = this.needsTables[this.indexTable]?.reasonMaps;
    } else {
      const tempFormationsNames = this.tempFormations.map((formation: Formation) => formation.name);
      let selectedReasonMaps: any[] = [];
      this.needsTables?.forEach((needsTable: any) => {
        if (tempFormationsNames.includes(needsTable.formation?.name)) {
          selectedReasonMaps = [...selectedReasonMaps, ...cloneDeep(needsTable.reasonMaps)];
        }
      });
      this.selectedReasonMaps = selectedReasonMaps;
    }
    this.inactiveDaysMap = this.mapInactiveDays(this.selectedReasonMaps);

    for (let i = 0; i < this.nbDays; i++) {
      this.computeDayNeeds(i, -1);
    }

    this.computeEffectifs();

    this.isDataLoading = false;
  }

  computeEffectifs() {
    if (!Array.isArray(this.effectifByReasonMap) || this.effectifByReasonMap.length === 0) {
      this.fillDefaultEffectifs();
      this.computeDiffs();
      return;
    }

    // C'est ici qu'on calcule les effectifs de chaque reason map
    this.selectedReasonMaps?.forEach((reasonMap: any) => {
      const effectifs = this.initializeZeroFilledArray(this.allDays.length);
      const currentEffectif = this.getCurrentEffectif(reasonMap._id);

      if (currentEffectif) {
        this.populateEffectifs(effectifs, currentEffectif);
      }

      reasonMap.effectifs = effectifs;
    });

    this.computeDiffs();
    this.computeDayEffectifs();
  }

  computeDayEffectifs() {
    if (!Array.isArray(this.selectedReasonMaps) || this.selectedReasonMaps.length === 0) {
      return;
    }

    this.dayEffectifs = this.initializeZeroFilledArray(this.allDays.length);
    this.selectedReasonMaps.forEach((selectedReasonMap: any) => {
      this.updateDayEffectifs(selectedReasonMap.effectifs);
    });
  }

  private updateDayEffectifs(reasonMapEffectifs: number[]): void {
    const effectifsLength = reasonMapEffectifs.length;

    for (let i = 0; i < effectifsLength; i++) {
      this.dayEffectifs[i] += reasonMapEffectifs[i];
    }
  }

  private initializeZeroFilledArray(length: number): number[] {
    return Array.from({ length }).fill(0) as number[];
  }

  private fillDefaultEffectifs(): void {
    this.selectedReasonMaps?.forEach((reasonMap: { effectifs?: number[] }) => {
      reasonMap.effectifs = this.initializeZeroFilledArray(this.allDays.length);
    });
  }

  private getCurrentEffectif(reasonMapId: string): EffectifByReasonMap['effectif'][0] | undefined {
    const effectifMap = this.effectifByReasonMap?.find(
      (eff: EffectifByReasonMap) => String(eff.reasonMapId) === String(reasonMapId)
    );
    if (this.selectedFormation && this.selectedFormation.name !== 'All') {
      return effectifMap?.effectif?.find((eff: { position: string }) => eff.position === this.selectedFormation?.name);
    }
    return effectifMap?.effectif[0];
  }

  private populateEffectifs(effectifs: number[], currentEffectif: EffectifByReasonMap['effectif'][0]): void {
    this.allDays.forEach((day: string, index: number) => {
      const formattedDate = moment(day).format('YYYY-MM-DD');
      const effectifsByDate = currentEffectif.byDates.filter(
        (byDate: { date: string }) => byDate.date === formattedDate
      );

      if (effectifsByDate.length > 0) {
        for (const effOfDate of effectifsByDate) {
          effectifs[index] += effOfDate?.count ?? 0;
        }
      }
    });
  }

  computeDiffs(): void {
    if (this.selectedReasonMaps?.length) {
      this.selectedReasonMaps.forEach(
        (reasonMap: { effectifs?: number[]; needs?: { need?: number }[]; diff?: number[] }) => {
          reasonMap.diff = this.calculateDiffs(reasonMap.effectifs, reasonMap.needs);
        }
      );
      this.generateScheduleDataFromReasonMaps();
    }
  }

  private calculateDiffs(effectifs?: number[], needs?: { need?: number }[]): number[] {
    if (!effectifs || !needs) {
      return Array(this.allDays.length).fill(0);
    }

    return effectifs.map((effectif: number, index: number): number => (effectif || 0) - (needs[index]?.need || 0));
  }

  saveAnesthNeedsListener() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.saveAnesthNeedsSubject, 'saveAnesthNeedsSubject', this.instanceId)
      .subscribe({
        next: () => {
          this.save();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  refreshAnesthNeedsListener() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.refreshAnesthNeedsSubject, 'refreshAnesthNeedsSubject', this.instanceId)
      .subscribe({
        next: () => {
          this.refresh();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  refresh(): void {
    this.hrsuiteService.isChangeAnesthNeedsSubject.next(false);
    this.thereIsChange = false;
    this.onChange.emit(false);
    this.isDataLoading = true;
    this.needsTables = [];
    this.getSurgeonOpenings();
  }

  isChangesUnsaved() {
    return this.thereIsChange;
  }

  async setLastUpdateMessage(data: any[]): Promise<void> {
    let lastUpdateDate: string | undefined;
    let lastUpdateUser: Profile | undefined;
    let updatedNeeds: any[] = [];

    if (data && typeof data === 'object' && Object.keys(data).length == 0 && this.day === this.previousDay) {
      lastUpdateUser = this.storageService.getUser().profile!;
    } else if (data && Object.keys(data).length > 0) {
      data.map((e: any) => (e.modified ? updatedNeeds.push(e) : null));
      if (updatedNeeds.length == 0) {
        updatedNeeds = data;
        lastUpdateUser = this.storageService.getUser().profile!;
      }

      let mostRecentDate: Date | null = null;
      updatedNeeds.forEach((e: any) => {
        if (e.updatedBy && typeof e.updatedBy === 'object') {
          const currentUpdatedAt = new Date(e.updatedAt);
          if (!mostRecentDate || currentUpdatedAt > mostRecentDate) {
            mostRecentDate = currentUpdatedAt;
            lastUpdateDate = e.updatedAt;
            if (!lastUpdateUser) {
              lastUpdateUser = e.updatedBy;
            }
          }
        }
      });
    }
    const arr = moment(lastUpdateDate).format('YYYY-MM-DD').split('-');
    const updateDate = arr[2] + '/' + arr[1] + '/' + arr[0];
    const updateHour = moment(lastUpdateDate).format('HH:mm');

    const doesAccessOptionsHaveIades = await this.userService.doesAccessOptionHaveIades(this.accessOption);
    const doesAccessOptionsHaveNurses = await this.userService.doesAccessOptionHaveIades(this.accessOption);
    const doesAccessOptionsHaveAnesthesistes = await this.userService.doesAccessOptionHaveAnesthesistes(
      this.accessOption
    );

    if (
      lastUpdateUser &&
      (lastUpdateUser.position === this.userService.getCurrentUser().profile?.position ||
        (doesAccessOptionsHaveIades && doesAccessOptionsHaveNurses && doesAccessOptionsHaveAnesthesistes))
    ) {
      this.lastUpdateMessage = `Modifié le ${updateDate} à ${updateHour}\npar ${lastUpdateUser.firstName} ${lastUpdateUser.lastName}\n`;
    } else {
      this.lastUpdateMessage = '';
    }
  }

  calculateWeekDays(index: any) {
    const date = new Date(this.day!);
    date.setDate(date.getDate() + index);

    this.allDays.push(moment(date).locale('fr').format('YYYY-MM-DD'));

    return moment(date).locale('fr').format('DD MMM');
  }

  calculateFullDays(index: number) {
    const date = new Date(this.day!);

    date.setDate(date.getDate() + index);

    return moment.utc(date).toISOString(true);
  }

  change() {
    this.thereIsChange = true;
    this.hrsuiteService.isChangeAnesthNeedsSubject.next(true);
    this.onChange.emit(true);
  }

  /**
   * Get user's population(s), a population being a set of formations
   * Small disclaimer, we'll sometimes use .*formations or .*positions.
   * 'formations' and 'positions' are used interchangeably as they mean the same thing
   */
  initPopulation(): void {
    this.subscriptionManager
      .createRequest(this.userConfigurationService.getUserConfigurations(), 'getUserConfigurations', this.instanceId)
      .subscribe({
        next: async (userConfiguration: any) => {
          // Init the toggle for "la frise hebdo"
          this.showFrise = userConfiguration.displayFriseHebdo ?? true;
          const accessOptionPositions = (
            await this.userService.getAccessOptionsPositionsByPositions(this.accessOption?.positions, true)
          ).map((formation: Formation) => formation._id);

          this.populationList = userConfiguration.population
            ? userConfiguration.population
                .filter((population: any) =>
                  population.formations.every((f: string) => accessOptionPositions.includes(f))
                )
                .sort((a: any, b: any) => a.priority - b.priority)
            : [];
          if (this.populationList.length > 0) {
            // Récupération de l'ID précédemment sélectionné (si disponible)
            const latestPopSelected = localStorage.getItem('latestPopSelected');

            this.currentPopulation.setValue(latestPopSelected || 'none', { emitEvent: true });
            //!!! important : le périmètre sera appliqué aprés avoir recupéré les paramedicals donc on appelle on population selected aprés le next

            // Construction des noms de formations pour affichage
            this.populationList.forEach((population: any) => {
              if (
                (population.profilesIds && population.profilesIds.length > 0) ||
                (population.residency && population.residency.length > 0)
              ) {
                population.formationsNames = 'Périmètre ciblé';
              } else {
                population.formationsNames = 'Périmètre global';
              }
            });
          }
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  onPopulationSelected() {
    this.thereIsChange = false;
    this.hrsuiteService.isChangeAnesthNeedsSubject.next(false);
    const population = this.populationList.find((pop: any) => pop._id === this.currentPopulation.value);
    if (this.currentPopulation.value && this.currentPopulation.value !== 'none') {
      localStorage.setItem('latestPopSelected', this.currentPopulation.value);
      this.tempReasonMaps = this.reasonMaps.filter((reason: any) =>
        population.roomsPerimeter.includes(reason.defaultRoom)
      );
      const allowedFormationIds = new Set(population.formations || []);

      const allowedFormationNames = Array.from(
        new Set(
          (this.paramedicals || [])
            .filter((pm: any) => pm?.formation && allowedFormationIds.has(pm.formation._id))
            .map((pm: any) => pm.formation.name)
        )
      );

      this.tempFormations = this.formations.filter((f: Formation) => allowedFormationNames.includes(f.name));
      if (
        !allowedFormationIds.has(this.selectedFormation?._id) &&
        Array.isArray(this.tempFormations) &&
        this.tempFormations.length > 0
      ) {
        if (this.tempFormations.length === 1) {
          this.selectedFormation = this.tempFormations[0];
        } else {
          this.selectedFormation = { name: 'All', _id: '0' };
        }
      }
    } else {
      localStorage.removeItem('latestPopSelected');
      this.tempFormations = this.formations;
      this.tempReasonMaps = this.reasonMaps;
    }
    this.mapReasonMapsToNeedsTables();
  }

  increaseNeeds(i: number, needs: any[], tableIndex: number, reasonMapIndex: number): any {
    const currentValue = needs[i].need;

    if (currentValue < 999) {
      const newValue = currentValue + 1;

      if (tableIndex >= 0) {
        this.needsTables[tableIndex].reasonMaps[reasonMapIndex].needs[i].need = newValue;
        this.needsTables[tableIndex].reasonMaps[reasonMapIndex].needs[i].modified = true;
      } else {
        const rmp = this.selectedReasonMaps[reasonMapIndex];
        rmp.needs[i].need = newValue;
        rmp.needs[i].modified = true;
        const position = rmp.positions[0];

        const needsTable = this.needsTables.find((t: any) => t.formation.name === position);

        const rmptoChange = needsTable.reasonMaps.find((rmap: any) => rmap._id === rmp._id);
        if (rmptoChange) {
          rmptoChange.needs[i].need = newValue;
          rmptoChange.needs[i].modified = true;
        }
      }

      this.change();
      this.dayNeeds[i] += 1;

      this.computeDiffs();

      return newValue;
    }
    return currentValue;
  }

  decreaseNeeds(i: number, needs: any[], tableIndex: number, reasonMapIndex: number): any {
    const currentValue = needs[i].need;

    if (currentValue < 999) {
      const newValue = currentValue - 1;

      if (tableIndex >= 0) {
        this.needsTables[tableIndex].reasonMaps[reasonMapIndex].needs[i].need = newValue;
        this.needsTables[tableIndex].reasonMaps[reasonMapIndex].needs[i].modified = true;
      } else {
        const rmp = this.selectedReasonMaps[reasonMapIndex];
        rmp.needs[i].need = newValue;
        rmp.needs[i].modified = true;
        const position = rmp.positions[0];

        const needsTable = this.needsTables.find((t: any) => t.formation.name === position);

        const rmptoChange = needsTable.reasonMaps.find((rmap: any) => rmap._id === rmp._id);
        if (rmptoChange) {
          rmptoChange.needs[i].need = newValue;
          rmptoChange.needs[i].modified = true;
        }
      }

      this.change();
      this.dayNeeds[i] -= 1;

      this.computeDiffs();

      return newValue;
    }
    return currentValue;
  }

  validateNeed(i: number, needs: any, tableIndex: number, reasonMapIndex: number): any {
    const min = 0;
    const max = 999;
    const clampedValue = Math.min(Math.max(needs[i]?.need, min), max);

    this.needsTables[tableIndex].reasonMaps[reasonMapIndex].modified = true;
    this.computeDayNeeds(i, reasonMapIndex, clampedValue);
    return clampedValue;
  }

  computeDayNeeds(dayIndex: number, reasonMapIndex: number, value?: number) {
    let needsCount = 0;
    this.selectedReasonMaps?.forEach((reasonMap: any, index: number) => {
      if (index === reasonMapIndex && value !== undefined) {
        needsCount += value;
      } else {
        needsCount += Number(reasonMap.needs[dayIndex]?.need) || 0;
      }
    });
    this.dayNeeds[dayIndex] = needsCount;
  }

  getLastMonday(date: Date) {
    const dayOfWeek = date.getUTCDay();
    const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

    const lastMonday = new Date(date);
    lastMonday.setUTCDate(date.getUTCDate() - daysToSubtract);
    return lastMonday;
  }

  chosenDayHandler(event: any) {
    this.subscriptionManager.createRequest(this.goToNextEvent(), 'goToNextEvent2', this.instanceId).subscribe({
      next: (res: any) => {
        if (res !== 'cancel' && !res) {
          this.day = this.isoDate;
          this.save();
        }
        if (res !== 'cancel') {
          const newDate: Date = new Date(Date.UTC(event.value._i.year, event.value._i.month, event.value._i.date));
          const previousMonday = this.getLastMonday(newDate);
          this.day = previousMonday.toISOString();
          this.isoDate = previousMonday.toISOString();
          this.isDataLoading = true;
          this.needsTables = [];
          this.getSurgeonOpenings();
          this.thereIsChange = false;
          this.onChange.emit(false);
          this.weekDays = [];
          this.allDays = [];
          for (let i = 0; i < this.nbDays; i++) {
            this.weekDays.push(this.calculateWeekDays(i));
          }
        } else if (res === 'cancel') {
          this.refreshDateSubject.next();
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }

  onWeekChange(type: string) {
    this.subscriptionManager.createRequest(this.goToNextEvent(), 'goToNextEvent', this.instanceId).subscribe({
      next: (res: any) => {
        if (res === true) {
          const dateCopy = new Date(this.isoDate!);
          switch (type) {
            case 'previous':
              dateCopy.setUTCDate(dateCopy.getUTCDate() - 7);
              break;
            case 'next':
              dateCopy.setUTCDate(dateCopy.getUTCDate() + 7);
              break;
          }
          this.day = dateCopy.toISOString();
          this.hrsuiteService.isChangeAnesthNeedsSubject.next(false);
          this.onChange.emit(false);
          this.isoDate = dateCopy.toISOString();
          this.isDataLoading = true;
          this.needsTables = [];
          this.getSurgeonOpenings();
          this.thereIsChange = false;
          this.weekDays = [];
          this.allDays = [];
          for (let i = 0; i < this.nbDays; i++) {
            this.weekDays.push(this.calculateWeekDays(i));
          }
        } else if (res !== 'cancel') {
          this.day = this.isoDate;
          this.save();
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
  }

  goToNextEvent() {
    if (this.thereIsChange) {
      return this.utilisService.openUnSavedChangesPopup();
    } else {
      return new Observable((sub: any) => sub.next(true));
    }
  }

  formatSimpleDayNeeds() {
    const surgeonOpenings: any[] = [];

    const modifiedDaysSet = new Set<string>();
    this.needsTables.forEach((needTable: any) => {
      needTable.reasonMaps.forEach((reasonMap: any) => {
        reasonMap.needs.forEach((need: any) => {
          if (need.modified) {
            modifiedDaysSet.add(need.day);
          }
        });
      });
    });

    const modifiedDays = Array.from(modifiedDaysSet);

    modifiedDays.forEach((day: string) => {
      const dayIndex = this.days.indexOf(day);
      if (dayIndex === -1) {
        return;
      }

      const date = new Date(this.day!);
      date.setUTCDate(date.getUTCDate() + dayIndex);

      const reasonMapById: Map<string, any> = new Map();

      this.needsTables.forEach((needTable: any) => {
        needTable.reasonMaps.forEach((reasonMap: any) => {
          const needForDay = reasonMap.needs.find((n: any) => n.day === day);
          if (!needForDay) {
            return;
          }

          const existing = reasonMapById.get(reasonMap._id);
          const needObj = {
            role: needTable.role._id,
            need: needForDay.need,
          };

          if (existing) {
            existing.needs.push(needObj);
          } else {
            reasonMapById.set(reasonMap._id, {
              date: date.toISOString(),
              hospital: this.userService.getSelectedHospitals()[0],
              room: reasonMap.defaultRoom,
              surgeon: reasonMap.defaultSurgeon,
              opening: true,
              startTime: reasonMap.morningStartTime,
              endTime: reasonMap.afternoonEndTime,
              needs: [needObj],
              updatedBy: this.userService.getCurrentUser()?.profile?._id,
            });
          }
        });
      });

      surgeonOpenings.push(...Array.from(reasonMapById.values()));
    });

    return surgeonOpenings;
  }

  ngOnDestroy(): void {
    this.saveDate();
  }

  private calculateStartAndEndHours(selectedReasonMaps: any[]) {
    let earliestMinutes = Infinity;
    let latestMinutes = -Infinity;

    selectedReasonMaps.forEach((reasonMap: any) => {
      const { morningStartTime, afternoonEndTime, nightStartTime, nightEndTime } = reasonMap;
      const startTime = morningStartTime || nightStartTime;
      const endTime = afternoonEndTime || nightEndTime;

      if (startTime && endTime) {
        const startHour = new Date(startTime).getUTCHours();
        const startMinute = new Date(startTime).getUTCMinutes();
        const endHour = new Date(endTime).getUTCHours();
        const endMinute = new Date(endTime).getUTCMinutes();

        const startTotalMinutes = startHour * 60 + startMinute;
        const endTotalMinutes = endHour * 60 + endMinute;

        earliestMinutes = Math.min(earliestMinutes, startTotalMinutes);
        latestMinutes = Math.max(latestMinutes, endTotalMinutes);
      }
    });

    const startHour = Math.floor(earliestMinutes / 60);
    const endHour = Math.ceil(latestMinutes / 60);

    return [startHour, endHour];
  }

  private generateDayHoursAndIntervals(startHour: number, endHour: number): any {
    const dayHours = [];
    const intervals = [];

    for (let h = startHour!; h <= endHour!; h++) {
      const hourStr = `${h.toString().padStart(2, '0')}:00`;
      const halfHourStr = h < endHour! ? `${h.toString().padStart(2, '0')}:30` : undefined;

      dayHours.push({
        hour: hourStr,
        halfHour: halfHourStr,
      });

      // Generate 15-minute intervals for this hour
      intervals.push(
        { start: `${h.toString().padStart(2, '0')}:00`, end: `${h.toString().padStart(2, '0')}:14` },
        { start: `${h.toString().padStart(2, '0')}:15`, end: `${h.toString().padStart(2, '0')}:29` },
        { start: `${h.toString().padStart(2, '0')}:30`, end: `${h.toString().padStart(2, '0')}:44` },
        { start: `${h.toString().padStart(2, '0')}:45`, end: `${h.toString().padStart(2, '0')}:59` }
      );
    }

    return [dayHours, intervals];
  }

  private formatPercent(value: number): number {
    if (value >= 0 && value < 1) {
      return Math.ceil(value);
    }

    if (value >= 99 && value < 100) {
      return Math.floor(value);
    }

    return Math.round(value);
  }

  private calculateDayPercentages(scheduleData: any[][]): Array<{ percentage: number; percentageLabel: string }> {
    return scheduleData.map((dayData) => {
      const activeIntervals = dayData.filter((interval) => interval.isCoveredByReasonMaps && interval.need !== 0);
      const totalActiveIntervals = activeIntervals.length;

      if (totalActiveIntervals === 0) {
        return { percentage: 100, percentageLabel: 'neutral' };
      }

      const totalCoverageScore = activeIntervals.reduce((acc, interval) => {
        if (interval.value >= 0) {
          return acc + 1;
        }

        const coverageRatio = Math.min(Math.max(interval.effectif / interval.need, 0), 1);
        return acc + coverageRatio;
      }, 0);

      const percentage = this.formatPercent((totalCoverageScore / totalActiveIntervals) * 100);

      let percentageLabel: string;
      if (percentage < 80) {
        percentageLabel = 'low';
      } else if (percentage < 90) {
        percentageLabel = 'medium';
      } else {
        percentageLabel = 'high';
      }

      return { percentage, percentageLabel };
    });
  }

  private mergeConsecutiveIntervals(scheduleData: any[][]): any[][] {
    return scheduleData.map((dayData) => {
      const activeIntervals = dayData.filter((interval) => interval.isCoveredByReasonMaps);

      if (activeIntervals.length === 0) {
        return [];
      }

      const merged = [];
      let current = { ...activeIntervals[0] };

      for (let i = 1; i < activeIntervals.length; i++) {
        const next = activeIntervals[i];

        if (current.value === next.value) {
          current.endTime = next.endTime;
        } else {
          current.endTime = this.adjustEndTime(current.endTime);
          merged.push(current);
          current = { ...next };
        }
      }

      current.endTime = this.adjustEndTime(current.endTime);
      merged.push(current);

      return merged;
    });
  }

  private adjustEndTime(endTime: string): string {
    const [endHour, endMinute] = endTime.split(':').map(Number);

    if (endMinute === 14) {
      return `${endHour.toString().padStart(2, '0')}:15`;
    }
    if (endMinute === 29) {
      return `${endHour.toString().padStart(2, '0')}:30`;
    }
    if (endMinute === 44) {
      return `${endHour.toString().padStart(2, '0')}:45`;
    }
    if (endMinute === 59) {
      return `${(endHour + 1).toString().padStart(2, '0')}:00`;
    }

    return endTime;
  }

  save(): Promise<void> {
    return new Promise(async (resolve: any, reject: any) => {
      try {
        this.hrsuiteService.isSavingAnesthNeeds = true;

        this.subscriptionManager
          .createRequest(
            this.surgeonOpeningService.updateSimpleDayNeeds(this.formatSimpleDayNeeds()),
            'updateSimpleDayNeeds',
            this.instanceId
          )
          .subscribe({
            next: (dataR: any[]) => {
              this.hrsuiteService.isChangeAnesthNeedsSubject.next(false);
              this.hrsuiteService.isSavingAnesthNeeds = false;
              this.setLastUpdateMessage(dataR);
              this.thereIsChange = false;
              this.onChange.emit(false);
              this.utilisService.displaySuccessToast();
              resolve();
              this.getSurgeonOpenings();
              this.weekDays = [];
              for (let i = 0; i < this.nbDays; i++) {
                this.weekDays.push(this.calculateWeekDays(i));
              }
            },
            error: (error: any) => {
              this.hrsuiteService.isSavingAnesthNeeds = true;
              this.errorService.handleError(error);
              reject(error);
            },
          });

        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  toggleShowReasonMapsFromAdjustmentAlgo() {
    this.showReasonMapsFromAdjustmentAlgo = !this.showReasonMapsFromAdjustmentAlgo;
    this.mapReasonMapsToNeedsTables();
  }

  close() {
    this.dialogRef.close();
  }
}
